import React from 'react'
import Modal from 'react-modal'

import { shadow, border } from '../theme'

export const useModal = () => {
   Modal.setAppElement('#root')

   const customStyles = {
      content: {
         top: '50%',
         left: '50%',
         right: 'auto',
         bottom: 'auto',
         marginRight: '-50%',
         transform: 'translate(-50%, -100%)',
         border: 'none',
         borderRadius: border.radius,
         boxShadow: shadow.base,
         maxWidth: '60wv'
      }
   }

   const [modalIsOpen, setIsOpen] = React.useState(false)

   const ConfiguredModal = ({ children }) => (
      <Modal
         isOpen={modalIsOpen}
         onRequestClose={() => setIsOpen(false)}
         style={customStyles}
         contentLabel="Modal"
      >
         {children}
      </Modal>
   )
   return [ConfiguredModal, setIsOpen]
}

export default Modal
